// @flow
import React from 'react';
import { get, isEmpty } from 'lodash';
import { messageFormat as message } from '@clubmed/utils';

import bookingUtils from 'Utils/ple-utils/bookingUtils';
import { ICONS } from 'Components/utils/icon/icons';

import { TravelDetail } from 'Components/widgets/travel-details/travel-detail/TravelDetail.jsx';

type Props = {
  departureCity: string,
  arrivalCity: string,
  returnDate: string,
  bookingStatus: string,
  isJoyview: ?boolean,
  vendor?: BookingVendor,
  travelAdvisor: CMSTravelAdvisor,
  labels: {
    +transport: {
      from: string,
      to: string,
      callToUpsellTransportLabel: string,
    },
    withoutTransport: string,
    dedicatedJoyviewHotlineNumber?: string,
  },
  transportType?: string,
};

function formatCallToUpsellTransportLabel({ vendor, travelAdvisor, isJoyview, labels }) {
  const callToUpsellTransportLabel = get(labels, 'transport.callToUpsellTransportLabel');
  const params = {
    vendor,
    travelAdvisor,
    isJoyview,
    dedicatedJoyviewHotlineNumber: labels.dedicatedJoyviewHotlineNumber,
  };
  const agencyDetails = bookingUtils.getAgencyDetails(params);
  return callToUpsellTransportLabel
    ? message(callToUpsellTransportLabel).format({
        agencyNumber: get(agencyDetails, 'label', ''),
      })
    : '';
}

export default function TransportTravelDetails(props: Props) {
  if (isEmpty(props)) {
    return null;
  }

  const {
    departureCity,
    arrivalCity,
    returnDate,
    bookingStatus,
    labels = {},
    transportType,
  } = props;

  const hasTransport = departureCity && arrivalCity;
  const isSearch = bookingStatus === 'SEARCH';

  if (!hasTransport) {
    const highlightText =
      bookingUtils.isPastTrip(returnDate) || isSearch
        ? ''
        : formatCallToUpsellTransportLabel(props);
    return (
      <TravelDetail
        infos={{
          text1: labels.withoutTransport,
          highlightText2: highlightText,
        }}
        icon={ICONS.NO_TRANSPORT}
      />
    );
  }

  return (
    <TravelDetail
      infos={{
        text1: get(labels, 'transport.from'),
        highlightText1: departureCity,
        text2: get(labels, 'transport.to'),
        highlightText2: arrivalCity,
      }}
      icon={bookingUtils.getTranportIcon(transportType)}
    />
  );
}
